import { ReactComponent as PlainGlaze } from './plain_glaze.svg'
import { ReactComponent as ChocolateGlaze } from './chocolate_glaze.svg'
import { ReactComponent as StrawberryGlaze } from './strawberry_glaze.svg'
import { ReactComponent as MapleGlaze } from './maple_glaze.svg'
import { ReactComponent as BlueberryGlaze } from './blueberry_glaze.svg'
import { ReactComponent as PistachioGlaze } from './pistachio_glaze.svg'

const DonutGlazings = {
  PlainGlaze,
  ChocolateGlaze,
  StrawberryGlaze,
  MapleGlaze,
  BlueberryGlaze,
  PistachioGlaze,
}

export default DonutGlazings
